import React from 'react'
import Error from 'react-icons/lib/md/error-outline'

const NotFound  = ({ msg }) => (
  <div className="jumbotron">
    <h2 className="text-center"><Error />{' '}{msg}</h2>
    <hr />
  </div>
)

export default NotFound



// WEBPACK FOOTER //
// ./src/containers/COR2/not_found.js